import { Currency } from '@ps/web-core-enums';
import React from 'react';
import { useSelector } from 'react-redux';

import type { Props } from '@swf/components/CurrencyAmount/CurrencyAmount';
import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { select } from '@swf/core/store';

interface OwnProps {
  decimalClassName?: string;
}

const BalanceAmount: React.FC<Props & OwnProps> = ({ decimalClassName, ...rest }) => {
  const isPlayMoney = useSelector(select.currency.isPlayMoney);

  return (
    <CurrencyAmount {...rest} {...(isPlayMoney && { currency: Currency.PlayMoney })}>
      {(parts) => {
        const decimalIndex = parts.findIndex((part) => part.type === 'decimal');
        return (
          <>
            {parts
              .slice(0, decimalIndex)
              .map((part) => part.value)
              .join('')}
            <span className={decimalClassName}>
              {parts
                .slice(decimalIndex)
                .map((part) => part.value)
                .join('')}
            </span>
          </>
        );
      }}
    </CurrencyAmount>
  );
};

export default BalanceAmount;
